import { i18n as I18n } from '../utils/i18n';

export const EXEMPT_PAGES = [
  I18n.t('navigation.terms_and_conditions.url'),
  I18n.t('navigation.privacy_policy.url'),
];
